module.exports = __webpack_public_path__ + "img/cross-partners.d50db658.svg";